import { merge } from 'es-toolkit';
import { CLIENT_API_RETRY_LIMIT, CLIENT_API_TIMEOUT, FORCE_HTTPS_STREAMS, UNIFIED_EVENTS_BATCH_INTERVAL_SECS, UNIFIED_EVENTS_MAX_BATCH_COUNT, } from '../constants';
export class StoreClient {
    #options;
    #configData;
    #userData;
    #reportingContext = {};
    constructor(options) {
        this.#configData = options.configData;
        this.#options = {
            uiServiceOptions: {
                generateRoutePathForGuideItem: () => '',
            },
            ...options,
            proxyReauthMode: options.proxyReauthMode || 'enabled',
        };
        this.#setOptionsFromConfigData();
    }
    #setOptionsFromConfigData() {
        this.#options = {
            ...this.#options,
            timeout: this.getConfigSetting(CLIENT_API_TIMEOUT, 10_000),
            retries: this.getConfigSetting(CLIENT_API_RETRY_LIMIT, 2),
            unifiedEvents: {
                reportingIntervalDelaySecs: this.getConfigSetting(UNIFIED_EVENTS_BATCH_INTERVAL_SECS, 5),
                reportingMaxBatch: this.getConfigSetting(UNIFIED_EVENTS_MAX_BATCH_COUNT, 25),
            },
            forceHttpsStreams: this.getConfigSetting(FORCE_HTTPS_STREAMS, false),
        };
    }
    get options() {
        return this.#options;
    }
    set configData(configData) {
        const hadConfigData = !!this.#configData;
        this.#configData = configData;
        if (!hadConfigData) {
            this.#setOptionsFromConfigData();
        }
    }
    set userData(userData) {
        this.#userData = userData;
    }
    get isPremium() {
        return (this.#options.isPremiumOverride ??
            this.#userData?.subscriptions?.some((sub) => sub?.status === 'active') ??
            false);
    }
    get adsTargeting() {
        return this.#configData?.ads?.targeting ?? {};
    }
    get locationData() {
        return this.#configData?.location;
    }
    get reportingContext() {
        return this.#reportingContext;
    }
    updateOptions(options) {
        this.#options = merge(this.#options, options);
    }
    updateReportingContext(context) {
        this.#reportingContext = merge(this.#reportingContext, context);
    }
    getConfigSetting = (key, fallback) => {
        const setting = this.#configData?.autoupdate?.[key];
        return (setting ?? fallback);
    };
}
